import { makeSubstitutionModule } from "./FormulaSubstitutionShared";

export const TYPE = "FormulaSubstitutionBasicTask";

const TEMPLATES = [
  {
    prompt: "Podstaw dane liczby do wzoru i oblicz wartość wyrażenia.",
    formulaLatex: "y=3x+5",
    valuesLatex: "x=7",
    answerSymbol: "y",
    answerLabelLatex: "y",
    answer: 26,
    substitutionLatex: "y=3\\cdot 7+5",
    resultLatex: "26",
  },
  {
    prompt: "Podstaw dane liczby do wzoru i oblicz wartość wyrażenia.",
    formulaLatex: "a=2b-c",
    valuesLatex: "b=9,\\ c=4",
    answerSymbol: "a",
    answerLabelLatex: "a",
    answer: 14,
    substitutionLatex: "a=2\\cdot 9-4",
    resultLatex: "14",
  },
  {
    prompt: "Podstaw dane liczby do wzoru i oblicz wartość wyrażenia.",
    formulaLatex: "w=5p+2q",
    valuesLatex: "p=4,\\ q=6",
    answerSymbol: "w",
    answerLabelLatex: "w",
    answer: 32,
    substitutionLatex: "w=5\\cdot 4+2\\cdot 6",
    resultLatex: "32",
  },
];

const moduleApi = makeSubstitutionModule(TYPE, TEMPLATES);

export const generateTask = moduleApi.generateTask;
export const renderTask = moduleApi.renderTask;
export const renderInput = moduleApi.renderInput;
export const checkAnswer = moduleApi.checkAnswer;
export const renderAnswer = moduleApi.renderAnswer;
export const renderUserAnswer = moduleApi.renderUserAnswer;
export const renderExplanation = moduleApi.renderExplanation;